/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.12.16",
    versionName: "0.2.0-nightly.2025.12.16",
    versionChannel: "nightly",
    buildDate: "2025-12-16T00:08:22.217Z",
    commitHash: "13b4fdfdd8529d4df0ecb5ca0fc6497aebedbd85",
};
